import { __assign } from "tslib";
import React, { Suspense, useState } from 'react';
import { themes } from '../../ThemeOptions';
import Skeletons from './Skeleton';
var loading = function (ioMode, ioTheme, styleName) {
    return React.createElement(Skeletons, { count: 1, ioMode: ioMode, ioTheme: ioTheme, styleName: styleName });
};
var BootStrapModal = React.lazy(function () {
    return import('../../bootstrap-components/components/BTFullSizeModal');
});
var bootStrapModal = function (props) {
    var _a = useState(props.maximized ? true : false), max = _a[0], setMax = _a[1];
    var handleClose = function () {
        props.toggle(!props.isOpen);
    };
    var setSize = function () {
        setMax(!max);
    };
    return React.createElement(BootStrapModal, __assign({}, props, { toggle: function () { return handleClose(); }, expand: function () { return setSize(); }, maximized: max }));
};
var FullSizeModal = function (props) {
    var componentToDisplay;
    switch (props.ioTheme.uiLibrary) {
        case 'materialui':
            componentToDisplay = bootStrapModal(props);
            break;
        default:
            componentToDisplay = bootStrapModal(props);
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Suspense, { fallback: loading(props.ioMode, props.ioTheme, props.styleName) }, componentToDisplay)));
};
FullSizeModal.defaultProps = {
    styleName: 'primary',
    ioTheme: themes[0],
    ioMode: 'light',
    name: 'FullSizeModal',
    maximized: true
};
export default FullSizeModal;
//# sourceMappingURL=FullSizeModal.js.map